export default __webpack_public_path__ + "static/media/yellow.b21c885e.png";